import { render, staticRenderFns } from "./EditActiveBonusModal.vue?vue&type=template&id=7ec35074&"
import script from "./EditActiveBonusModal.vue?vue&type=script&lang=js&"
export * from "./EditActiveBonusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports